// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import CheckRepaymentsFundsController from "./check_repayments_funds_controller";
application.register("repayments-funds", CheckRepaymentsFundsController);

import OffersSelectController from "./offers_select_controller";
application.register("offers-select", OffersSelectController);

import RemoverController from "./remover_controller";
application.register("remover", RemoverController);

import SelectController from "./select_controller";
application.register("select", SelectController);

import SignatureController from "./signature_controller";
application.register("signature", SignatureController);

import TinymceController from "./tinymce_controller";
application.register("tinymce", TinymceController);
